import { useState } from "react";
import { useForm } from "react-hook-form";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";
import { toast } from "react-toastify";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

const ImportInvoiceModal = ({ modal, toggle }) => {
    const [isLoading, setIsLoading] = useState(false);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const closeHandler = () => {
        toggle();
        reset();
    };


    const onSubmit = (data) => {
        const file = data?.invoice_imports?.[0];
        if (file && file.size > 6 * 1024 * 1024) {
            toast.error("File size must be less than 6MB");
            return;
        }
        let formData = new FormData();
        formData.append("invoice_imports", file);

        const options = {
            method: "POST",
            form_data: formData,
        };

        let API = apiUrl?.import_invoice_data;
        setIsLoading(true);
        callApi(API, options).then((response) => {
            setIsLoading(false);
            if (response?.status === true) {
                toast.success(response?.message);
                closeHandler();
            } else {
                toast.error(response?.message);
            }
        });
    };

    return (
        <Modal
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
            isOpen={modal}
            toggle={closeHandler}
            centered
        >
            <ModalHeader toggle={closeHandler} className="bg-light">
                <div className="d-flex align-items-center">
                    <i className="bi bi-file-earmark-spreadsheet fs-4 me-2"></i>
                    <h4 className="mb-0">Import Invoice Excel File</h4>
                </div>
            </ModalHeader>

            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody className="p-4">
                    <div className="modal-content border-0">
                        <div className="d-flex justify-content-center">
                            <i className="bi bi-cloud-arrow-up text-primary fs-1"></i>
                        </div>
                        <p className="text-center text-secondary mb-3">Bulk Update Invoice Data</p>
                        <div className="row">
                            {/* Import File */}
                            <div className="col-12">
                                <div className="form-group mb-4">
                                    <label htmlFor="invoice_imports" className="form-label ms-1 fw-bold text-secondary d-flex align-items-center">
                                        Import File
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="invoice_imports"
                                            accept=".xlsx"
                                            {...register("invoice_imports", {
                                                required: "Please select a file to upload",
                                            })}
                                        />
                                    </div>
                                    <div className="mt-1">
                                        <ErrorMessage
                                            message={errors?.invoice_imports?.message}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="bg-light">
                    <button
                        type="button"
                        className="btn btn-outline-secondary px-4"
                        onClick={closeHandler}
                    >
                        Close
                    </button>
                    <button type="submit" className="btn btn-primary px-4 d-flex align-items-center">
                        {isLoading ? (
                            <><Spinner size="sm" className="me-2" /> Submitting...</>
                        ) : (
                            <><i className="bi bi-save me-2"></i> Submit</>
                        )}
                    </button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default ImportInvoiceModal;
